// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__+nPRX","dark":"Layout_dark__z0xXk","container":"Layout_container__nqBu4"};